var _g, _path, _g2, _path2, _path3, _g3, _g4, _g5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgSmartlinkBanner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 381,
    height: 159,
    viewBox: "0 0 381 159",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_7646_4650)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 93C18 83.0589 26.0589 75 36 75H341C350.941 75 359 83.0589 359 93V111C359 120.941 350.941 129 341 129H36C26.0589 129 18 120.941 18 111V93Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M163.453 107H159.117V93.4H163.309C167.597 93.4 170.013 95.848 170.013 100.2C170.013 104.52 167.629 107 163.453 107ZM163.309 95.4H161.117V105H163.453C166.317 105 167.997 103.224 167.997 100.2C167.997 97.128 166.317 95.4 163.309 95.4ZM171.171 102.184C171.171 99.416 173.235 97.288 175.891 97.288C178.547 97.288 180.595 99.416 180.595 102.184C180.595 104.968 178.547 107.096 175.891 107.096C173.235 107.096 171.171 104.968 171.171 102.184ZM175.891 99.288C174.355 99.288 173.171 100.536 173.171 102.184C173.171 103.848 174.355 105.096 175.891 105.096C177.427 105.096 178.595 103.848 178.595 102.184C178.595 100.536 177.427 99.288 175.891 99.288ZM188.538 102.184C188.538 100.424 187.626 99.288 186.218 99.288C184.922 99.288 183.978 100.504 183.978 102.2V107H181.978V97.4H183.978V98.968C184.33 97.992 185.386 97.288 186.57 97.288C189.002 97.288 190.538 99.224 190.538 102.184V107H188.538V102.184ZM199.602 107V105.432C199.186 106.408 197.89 107.096 196.546 107.096C193.778 107.096 191.97 105.144 191.97 102.184C191.97 99.24 193.762 97.288 196.546 97.288C197.874 97.288 199.186 97.976 199.602 98.968V97.4H201.602V107H199.602ZM193.97 102.184C193.97 103.944 195.122 105.096 196.802 105.096C198.466 105.096 199.618 103.928 199.602 102.2C199.602 100.488 198.418 99.288 196.786 99.288C195.106 99.288 193.97 100.44 193.97 102.184ZM205.016 95.368H206.536V97.4H208.616V99.288H206.536V103.592C206.536 104.584 206.984 105.016 207.976 105.016H208.616V107H207.784C205.496 107 204.536 106.056 204.536 103.704V99.288H203.112V97.4H204.536L205.016 95.368ZM216.413 104.056H218.541C217.885 105.848 216.189 107.08 214.269 107.08C211.501 107.08 209.549 105.048 209.549 102.168C209.549 99.384 211.565 97.272 214.221 97.272C216.861 97.272 218.893 99.368 218.893 102.12C218.893 102.376 218.877 102.648 218.829 102.888H211.613C211.869 104.28 212.893 105.192 214.253 105.192C215.245 105.192 216.045 104.728 216.413 104.056ZM211.613 101.432H216.829C216.573 100.088 215.549 99.16 214.221 99.16C212.893 99.16 211.885 100.072 211.613 101.432Z",
    fill: "url(#paint0_linear_7646_4650)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_7646_4650)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 20.6809C18 9.25913 27.2591 0 38.6809 0H338.553C349.975 0 359.234 9.25913 359.234 20.6808V33.3191C359.234 44.7409 349.975 54 338.553 54H38.6808C27.2591 54 18 44.7409 18 33.3191V20.6809Z",
    fill: "url(#paint1_linear_7646_4650)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4403 26.7557C40.4403 22.5699 42.74 19.6415 46.2806 19.6415C49.8211 19.6415 52.1374 22.5699 52.1374 26.7557C52.1374 30.9415 49.8211 33.8865 46.2806 33.8865C42.74 33.8865 40.4403 30.9415 40.4403 26.7557ZM46.2806 21.9578C44.1132 21.9578 42.8062 23.9431 42.8062 26.7557C42.8062 29.6014 44.1132 31.5702 46.2806 31.5702C48.4479 31.5702 49.7715 29.6014 49.7715 26.7557C49.7715 23.9266 48.4479 21.9578 46.2806 21.9578ZM52.8811 32.5298C52.8811 31.7357 53.4105 31.2063 54.2378 31.2063C55.0485 31.2063 55.5613 31.7357 55.5613 32.5298C55.5613 33.3405 55.0485 33.8865 54.2378 33.8865C53.4105 33.8865 52.8811 33.3405 52.8811 32.5298ZM56.3144 26.7557C56.3144 22.5699 58.6142 19.6415 62.1547 19.6415C65.6953 19.6415 68.0115 22.5699 68.0115 26.7557C68.0115 30.9415 65.6953 33.8865 62.1547 33.8865C58.6142 33.8865 56.3144 30.9415 56.3144 26.7557ZM62.1547 21.9578C59.9874 21.9578 58.6803 23.9431 58.6803 26.7557C58.6803 29.6014 59.9874 31.5702 62.1547 31.5702C64.3221 31.5702 65.6456 29.6014 65.6456 26.7557C65.6456 23.9266 64.3221 21.9578 62.1547 21.9578ZM69.2602 26.7557C69.2602 22.5699 71.5599 19.6415 75.1004 19.6415C78.641 19.6415 80.9573 22.5699 80.9573 26.7557C80.9573 30.9415 78.641 33.8865 75.1004 33.8865C71.5599 33.8865 69.2602 30.9415 69.2602 26.7557ZM75.1004 21.9578C72.9331 21.9578 71.6261 23.9431 71.6261 26.7557C71.6261 29.6014 72.9331 31.5702 75.1004 31.5702C77.2678 31.5702 78.5914 29.6014 78.5914 26.7557C78.5914 23.9266 77.2678 21.9578 75.1004 21.9578ZM84.4839 31.4213H91.8463V33.7872H82.1346V31.8515C82.1346 28.6749 84.3019 27.5333 86.3535 26.491C88.8848 25.184 89.3977 24.6546 89.3977 23.5792C89.3977 22.5699 88.5043 21.8916 87.1642 21.8916C85.7744 21.8916 84.8976 22.5699 84.8314 23.7281H82.4655C82.482 20.8824 84.7156 19.6415 87.1642 19.6415C89.7121 19.6415 91.747 20.8989 91.747 23.6123C91.747 26.8716 88.1072 28.0462 86.7836 28.708C85.3773 29.4029 84.4839 30.4287 84.4839 31.4213ZM96.6341 25.4818H98.0404C99.5129 25.4818 100.406 24.7042 100.406 23.5792C100.406 22.4707 99.6122 21.8254 98.1893 21.8254C96.7334 21.8254 95.8234 22.5368 95.7738 23.7115H93.4079C93.4245 20.8327 95.7076 19.5754 98.1728 19.5754C100.787 19.5754 102.838 20.8493 102.838 23.6288C102.838 24.7869 102.392 25.7796 101.581 26.491C102.574 27.2024 103.136 28.2448 103.136 29.5518C103.136 32.5298 100.936 33.8865 98.1562 33.8865C95.5256 33.8865 93.1101 32.6291 93.0936 29.7503H95.4595C95.5091 30.9415 96.5514 31.6364 98.1562 31.6364C99.8272 31.6364 100.787 30.8919 100.787 29.6014C100.787 28.3771 99.7445 27.6988 98.0239 27.6988H96.6341V25.4818Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M307.215 22.0736H301.127V25.5811H307.066V27.9304H301.127V31.4213H307.364V33.7872H298.761V19.7243H307.215V22.0736ZM314.643 33.7872H312.293V22.0736H308.24V19.7243H318.713V22.0736H314.643V33.7872ZM322.162 33.7872H319.796V19.7243H322.162V25.5811H328.3V19.7243H330.65V33.7872H328.3V27.9304H322.162V33.7872Z",
    fill: "white"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_7646_4650)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M213 120.734V105.578C213 104.049 214.705 103.136 215.977 103.985L229.139 112.759C230.645 113.763 230.046 116.103 228.242 116.26L221.277 116.866C220.76 116.911 220.283 117.163 219.956 117.566L216.401 121.942C215.264 123.341 213 122.537 213 120.734Z",
    fill: "#262949"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213 120.734V105.578C213 104.049 214.705 103.136 215.977 103.985L229.139 112.759C230.645 113.763 230.046 116.103 228.242 116.26L221.277 116.866C220.76 116.911 220.283 117.163 219.956 117.566L216.401 121.942C215.264 123.341 213 122.537 213 120.734Z",
    stroke: "white",
    strokeWidth: 1.91489
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_7646_4650)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89 85.799L98.9249 84.1448C103.14 83.4424 106.442 80.1396 107.145 75.9249L108.799 66L110.453 75.9249C111.156 80.1396 114.458 83.4424 118.673 84.1448L128.598 85.799L118.673 87.4531C114.458 88.1556 111.156 91.4583 110.453 95.6731L108.799 105.598L107.145 95.6731C106.442 91.4583 103.14 88.1556 98.9249 87.4531L89 85.799Z",
    fill: "url(#paint2_linear_7646_4650)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_7646_4650)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M124 101.1L129.063 100.257C131.213 99.8983 132.898 98.2134 133.257 96.0632L134.101 91L134.944 96.0632C135.303 98.2134 136.988 99.8983 139.138 100.257L144.201 101.1L139.138 101.944C136.988 102.303 135.303 103.988 134.944 106.138L134.101 111.201L133.257 106.138C132.898 103.988 131.213 102.303 129.063 101.944L124 101.1Z",
    fill: "#EA7E68"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_7646_4650",
    x: 0,
    y: 65,
    width: 381,
    height: 94,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.868831 0 0 0 0 0.30204 0 0 0 0 0.202018 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7646_4650"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7646_4650",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_7646_4650",
    x: 18,
    y: 0,
    width: 343.532,
    height: 59.7447,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2.29787,
    dy: 5.74468
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.59574
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_7646_4650"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_7646_4650",
    x: 207.447,
    y: 102.701,
    width: 28.1016,
    height: 30.1029,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.59574
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.29787
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7646_4650"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7646_4650",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_7646_4650",
    x: 81,
    y: 61,
    width: 59.5977,
    height: 59.598,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.842371 0 0 0 0 0.677465 0 0 0 0 0.908333 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7646_4650"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7646_4650",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_7646_4650",
    x: 119.919,
    y: 88.4492,
    width: 30.4023,
    height: 30.4041,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.02031,
    dy: 2.55076
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.55076
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.842371 0 0 0 0 0.677465 0 0 0 0 0.908333 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7646_4650"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7646_4650",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7646_4650",
    x1: 207.721,
    y1: 91.026,
    x2: 201.362,
    y2: 120.121,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE7970"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB776"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7646_4650",
    x1: 371.597,
    y1: -0.00000276636,
    x2: 323.879,
    y2: 131.786,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8D8C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDBCFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7646_4650",
    x1: 106.421,
    y1: 71.464,
    x2: 115.163,
    y2: 99.234,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF968F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A2FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgSmartlinkBanner);
export default __webpack_public_path__ + "static/media/img-smartlink-banner.ced3e00a16b41f74717b916ef0d18c13.svg";
export { ForwardRef as ReactComponent };